import { CLIENTS_LOADED, UPDATE_SINGLE_CLIENT } from "../constants/actionTypes";

export default (state = {}, action) => {
    switch (action.type) {
    case CLIENTS_LOADED:
        return  {
            ...state,
            clients: action.clients,
            clientsTotal: action.total,
        };
    case UPDATE_SINGLE_CLIENT:
        const updatedClients = state.clients.map(client => {
            if(client.cars._id === action.payload.carId) {
                let car = action.payload.client.cars.find(c => c._id === action.payload.carId);
                client.cars.loan.phoneCalls = car.loan.phoneCalls;
            }
            return client;
        })
        return  {
            ...state,
            clients: updatedClients,
        };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/clients.js